var __jsx = React.createElement;
import { cn } from '@lib/cn';
import Icons from '@modules/icons';
import React from 'react';

/**
 * Displays a card component with an error message
 */
const ErrorMessageCard = _ref => {
  let {
    message,
    textClassname = ''
  } = _ref;
  return __jsx("div", {
    className: cn('flex flex-row gap-4 w-full h-fit p-4 text-white bg-error-main rounded-xl font-thin', textClassname)
  }, __jsx(Icons.errorOutlined, {
    size: 27
  }), message);
};
export default ErrorMessageCard;